export enum PerfilEnum {
  ADMINISTRADOR = 'Administrador',
  RESTAURANTE = 'Restaurante',
  USUARIO = 'Usuário',
}
